import { render, staticRenderFns } from "./PrintCalls.vue?vue&type=template&id=4d6c6e60&"
import script from "./PrintCalls.vue?vue&type=script&lang=js&"
export * from "./PrintCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports